import { palette } from '@livable/saas-react-components';
const MuiTabs = {
  styleOverrides: {
    root: {
      zIndex: '100'
    },
    scroller: {
      width: '100%'
    },
    indicator: {
      height: '3px',
      borderRadius: '3px 3px 0 0'
    },
    scrollButtons: {
      '&.Mui-disabled': {
        opacity: '0.5'
      }
    }
  },
  variants: [{
    props: {
      type: 'navigation'
    },
    style: {
      background: palette.gradients.white,
      borderBottom: "1px solid ".concat(palette.shades[300]),
      padding: '0 40px',
      minHeight: '60px',
      boxShadow: palette.shadows.light
    }
  }, {
    props: {
      type: 'innerNavigation'
    },
    style: {
      background: palette.gradients.white,
      borderBottom: "1px solid ".concat(palette.shades[300]),
      padding: '0 64px',
      minHeight: '54px'
    }
  }, {
    props: {
      type: 'sidebar'
    },
    style: {
      marginTop: '0px',
      paddingTop: '20px',
      background: palette.shades[200],
      color: palette.shades[700],
      '.MuiTab-root': {
        marginRight: '0',
        fontFamily: palette.fontFamilies.source,
        alignItems: 'flex-start',
        '&:after': {
          content: 'none'
        },
        '&.Mui-selected': {
          color: palette.primary.dark
        }
      },
      '.MuiTabs-indicator': {
        width: '3px',
        backgroundColor: palette.primary.dark,
        borderRadius: '3px 0 0 3px'
      },
      '.MuiTabScrollButton-vertical': {
        borderTop: "1px solid ".concat(palette.shades[300]),
        borderBottom: "1px solid ".concat(palette.shades[300]),
        transition: "opacity ".concat(palette.transitions.short),
        '&.Mui-disabled': {
          opacity: '0.3'
        }
      }
    }
  }, {
    props: {
      position: 'sticky'
    },
    style: {
      width: '100%',
      position: 'sticky',
      top: '0',
      left: '0',
      right: '0',
      zIndex: '20'
    }
  }, {
    props: {
      type: 'wizardSidebar'
    },
    style: {
      color: palette.shades[700],
      position: 'fixed',
      top: '0',
      left: '0',
      bottom: '0',
      '.MuiTab-root': {
        minHeight: '50px',
        padding: '15px 24px',
        marginRight: '0',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        '.MuiSvgIcon-root': {
          marginBottom: '0',
          marginRight: '10px',
          '& path': {
            fill: palette.shades[600]
          }
        },
        '&:after': {
          content: 'none'
        },
        '&.Mui-selected': {
          color: palette.shades[800],
          backgroundColor: palette.shades[200],
          '.MuiTab-wrapper .MuiSvgIcon-root path': {
            fill: palette.primary.dark
          }
        },
        '&:hover .MuiSvgIcon-root path': {
          fill: palette.shades[700]
        }
      },
      '.MuiTabs-indicator': {
        width: '3px',
        backgroundColor: palette.primary.dark,
        borderRadius: '3px 0 0 3px',
        left: 'initial',
        right: '0'
      },
      '.MuiTabScrollButton-vertical': {
        borderTop: "1px solid ".concat(palette.shades[300]),
        borderBottom: "1px solid ".concat(palette.shades[300]),
        transition: "opacity ".concat(palette.transitions.short),
        '&.Mui-disabled': {
          opacity: '0.3'
        }
      }
    }
  }]
};
export default MuiTabs;